module.exports = __webpack_public_path__ + "img/Copyright_pic03.0313f827.jpg";